import * as React from "react";
import { Company } from "../../../../domain/model/company";
import { Customer, Status } from "../../../../domain/model/customer";
import * as p from "../../../../domain/model/project";
import { Project } from "../../../../domain/model/project";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import ProjectView from "../../../common/template/page_project/project_veiw";

interface IProps {
  project: Project | null;
  company: Company | null;
  customer: Customer | null;
  handleCreateEntry: () => void;
  isEntry: boolean;
}

export const CustomerProjectMain: React.FC<IProps> = (props) => {
  const { project, company, customer, handleCreateEntry, isEntry } = props;

  if (!project || !company || !customer) {
    return <div />;
  }

  const status: Status = customer.status;

  let entryButton: JSX.Element;
  switch (true) {
    // アクティブユーザーではない場合
    case status !== Status.Status_Active: {
      entryButton = (
        <BtnCorporateLarge widthSize={"200px"} disabled={true}>
          エントリーする
        </BtnCorporateLarge>
      );
      break;
    }
    // アクティブユーザーかつエントリーしている場合
    case status === Status.Status_Active && isEntry: {
      entryButton = (
        <BtnCorporateLarge widthSize={"200px"} disabled={true}>
          エントリー済み
        </BtnCorporateLarge>
      );
      break;
    }
    // アクティブユーザーかつエントリーしてない場合
    case status === Status.Status_Active && !isEntry: {
      entryButton = (
        <BtnCorporateLarge widthSize={"200px"} onClick={handleCreateEntry}>
          エントリーする
        </BtnCorporateLarge>
      );
      break;
    }
    default: {
      entryButton = <div />;
    }
  }

  const isShow =
    project.status === p.Status.Status_Open ||
    (project.status === p.Status.Status_Contracted &&
      project.shouldShowByContract) ||
    (project.status === p.Status.Status_OnlyScout && project.shouldShowByScout);

  return (
    <React.Fragment>
      {isShow && (
        <>
          <ProjectView project={project} company={company} />
          <SubmitButtonWrapper>{entryButton}</SubmitButtonWrapper>
        </>
      )}
      {!isShow && <div>公開は終了しました</div>}
    </React.Fragment>
  );
};

export default CustomerProjectMain;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/project/customer_project_main.tsx